<template>
  <div class="lock-course"> 
    <Form :form_type="type"></Form>
  </div>
</template>

<script>

//引入求合作和锁定课程的公共组件
import Form from './components/matter-form';

export default {
  data(){
    return{
      type:1
    }
  },
  components:{
    Form
  }
}
</script>


<style lang="less" scoped>
  
</style>